<template>
    <div>
        

        <CButton v-if="!mostrarRightSidebar && $route.name === 'Documentos'"
            class="position-fixed d-flex align-items-center justify-content-center btnPrincipalVapp"
            style="top: 100px; right: 0px; z-index: 1051; width: 40px; height: 40px; border-radius: 50%; box-shadow: 0 2px 6px rgba(0,0,0,0.3);"
            @click="mostrarRightSidebar = !mostrarRightSidebar">
            <span class="pi pi-history"></span>
            <!--<CIcon name="cil-settings" />-->
        </CButton>
    <transition name="slide">
        <div v-if="mostrarRightSidebar" class="position-fixed border-left mt-4 mb-3" style="height : 95vh; top: 0; right: 0; width: 320px; z-index: 1050; background-color: #f8f9fa; 
            border-top-left-radius: 2rem;
            border-bottom-left-radius: 2rem;
            box-shadow: -2px 0 50px rgba(0,0,0,0.5); overflow-y: auto;">
            <div class="p-3 border-bottom d-flex justify-content-between align-items-center"
                style="background-color: #e9ecef;">
                <strong class="text-dark" style="font-size: 15px;">
                    <span class="pi pi-folder-open"></span> Documentos Procesados</strong>

                <CButton color="light" size="sm" @click="cerrarRightSidebar()">
                    <CIcon name="cil-x" />
                </CButton>
            </div>

            <div class="p-3">
                <!-- Aquí tu contenido -->
                    <CargandoInfo :mostrarCarga="obteniendoHistorico" :mensajeInfo="'Obteniendo información Historica...'" />
                <template v-if="archivosProcesados.length">
                    <CRow>
                        <CCol>
                            <!--Filtros-->
                            <div class="mt-2" v-if="archivosProcesados.length > 0">
                                <select v-model="filtroEstado" class="form-control form-control-sm"
                                    style="width: 180px;">
                                    <option value="todos">Todos</option>
                                    <option value="procesados">Procesados</option>
                                    <option value="error">Con Problemas</option>
                                </select>
                            </div>
                        </CCol>
                        <CCol>
                            <CButton size="sm"
                                class="btnPrincipalVapp float-right mt-1"
                                @click="elimiarHistorico()">
                                <CIcon size="sm" :content="$options.freeSet.cilTrash" />
                            </CButton>
                        </CCol>
                    </CRow>
                    <transition-group
                        name="fade-slide"
                        tag="div"
                        class="lista-archivos">
                        <div v-for="(archivo, index) in obtenerArchivos()" :key="archivo.id || index" class="mt-2">
                            <CCard class="mb-2">
                                <CCardHeader>
                                    <div class="card-header-actions float-right">
                                        <CLink v-show="archivo.success || archivo.error"
                                            class="card-header-action btn-minimize"
                                            @click="archivo.mostrarMas = !archivo.mostrarMas">
                                            <CIcon v-show="archivo.mostrarMas" :content="$options.freeSet.cilChevronTop" />
                                            <CIcon v-show="!archivo.mostrarMas"
                                                :content="$options.freeSet.cilChevronBottom" />
                                        </CLink>
                                    </div>
                                    <CRow>
                                        <CCol sm="12" md="12" lg="12">
                                            <CRow>
                                                <CCol sm="10" md="0" lg="10" class="text-truncate d-inline-block w-90">
                                                    <span class="text-truncate d-inline-block w-90" style="font-size: 12px;"
                                                        v-tippy="getBaseTippy(`${archivo.name}`)">({{ archivo.size | prettyBytes }}) {{ archivo.name }}</span>
                                                </CCol>
                                                <CCol sm="2" md="2" lg="2">
                                                    
                                                    <span v-tippy="getBaseTippy(`Quitar Documento`)" @click="elimiarDocumento(archivo)">
                                                        <CIcon size="sm" :content="$options.freeSet.cilTrash" />
                                                    </span>
                                                </CCol>
                                                
                                            </CRow>
                                        </CCol>

                                    </CRow>
                                    <CRow>
                                        <CCol sm="12" md="12" lg="12">
                                            
                                            <span style="font-size: 9px;">
                                                Fecha Proceso: {{ formatearFecha(archivo.dateResponse || archivo.date) }}
                                            </span>
                                            <span class="ml-1">
                                                    <CBadge v-if="archivo.success"
                                                        :style="{ 'color': '#ffffff', 'background-color': getColorEstado(archivo) }">

                                                        {{ archivo.status }}
                                                    </CBadge>
                                                    <CBadge v-else :color="getColorEstado(archivo)">
                                                        {{ archivo.status }}
                                                    </CBadge>
                                                </span>
                                            <div style="font-size: 9px;">Desde: "{{ archivo.metodoDesde || 'Sin identificar' }}""</div>
                                            
                                        </CCol>
                                    </CRow>
                                    
                                </CCardHeader>
                                <CCollapse :show="archivo.mostrarMas" :duration="400">
                                    <CCardBody>
                                        <span v-if="archivo.success">{{ archivo.response.mensajeGeneral }}</span>
                                        <span v-else-if="archivo.error">
                                            <span v-if="archivo.status === 'Cancelado'">
                                                Subida cancelada por el usuario
                                            </span>
                                            <span v-if="archivo.status === 'SizeError'">
                                                {{ archivo.errorMensaje }}
                                            </span>
                                            <span v-else>
                                                {{ archivo.response.mensajeGeneral }}
                                            </span>
                                        </span>
                                    </CCardBody>
                                </CCollapse>
                            </CCard>
                        </div>
                    </transition-group>

                </template>
                <template v-else>
                    <p>No hay archivos procesados aún.</p>
                </template>
            </div>
        </div>
    </transition>
    </div>
</template>

<script>

import { freeSet } from "@coreui/icons";

import CargandoInfo from '@/views/utils/CargandoInfo'

export default {
    name: 'HistoricoDocumentos',
    freeSet,
    components: {
        CargandoInfo
    },
    props: {

    },

    data() {
        return {
            obteniendoHistorico: false,
            mostrarRightSidebar: false,
            archivosProcesados: [],
            filtroEstado: 'todos',

        }
    },
    mounted() {

    },
    watch: {
        mostrarRightSidebar(nuevo) {
            this.obteniendoHistorico = true;
            if (nuevo) {
                const data = JSON.parse(localStorage.getItem('hitoricoArchivosProcesados')) || null;
                this.archivosProcesados = data ? data.archivos : [];
            }
            this.obteniendoHistorico = false;
        }
    },
    methods: {
        cerrarRightSidebar: function(){
            this.mostrarRightSidebar = false
            //this.$emit('cerrarRightSidebar')
        },
        elimiarHistorico: function () {
            this.archivosProcesados = [];
            localStorage.removeItem('hitoricoArchivosProcesados');
            
        },
        elimiarDocumento: function (archivo) {
            console.log("Eliminando documento:", archivo);
            this.archivosProcesados = this.archivosProcesados.filter(a => a.id !== archivo.id);
            localStorage.setItem('hitoricoArchivosProcesados', JSON.stringify({ archivos: this.archivosProcesados }));
        },
        obtenerArchivos: function () {
            return this.archivosProcesados.slice()
                .sort((a, b) => new Date(b.dateResponse || b.date) - new Date(a.dateResponse || a.date))
                .filter(archivo => {
                    if (this.filtroEstado === 'todos') return true;
                    if (this.filtroEstado === 'procesados') return archivo.success;
                    if (this.filtroEstado === 'error') return archivo.error;
                    return true;
                })
        },
        getColorEstado: function (archivo) {
            if (archivo.success) return '#2eb85c'
            else if (archivo.active && parseInt(archivo.progress) < 100) return 'warning'
            else if (archivo.active && parseInt(archivo.progress) === 100) return 'warning'
            else if (archivo.error) return 'danger'

            else return "secondary"
        },
        formatearTamanio(bytes) {
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            if (bytes === 0) return '0 Byte';
            const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
        },
        formatearFecha(fecha) {
            if (!fecha) return '-';
            const f = new Date(fecha);
            return f.toLocaleString('es-CL', {
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: '2-digit', minute: '2-digit'
            });
        },
    }
}
</script>

<style scoped>
.fade-slide-enter-active, .fade-slide-leave-active {
  transition: all 0.4s ease;
}
.fade-slide-enter-from, .fade-slide-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

.slide-enter-active,
.slide-leave-active {
    transition: transform 0.3s ease;
}

.slide-enter,
.slide-leave-to {
    transform: translateX(100%);
}

td,
th {
    font-size: 13px;
    color: #495057;
    padding: 6px 8px !important;
    vertical-align: middle;
    word-break: break-word;
}

th {
    background-color: #dee2e6 !important;
    color: #343a40;
    font-weight: 600;
}
</style>